import { render, staticRenderFns } from "./subs__list.vue?vue&type=template&id=3b3e97c1"
import script from "./subs__list.vue?vue&type=script&lang=js"
export * from "./subs__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports